import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list"]

  add() {
    const count = this.listTarget.querySelectorAll(".wizard-section-row").length + 1
    const row = document.createElement("div")
    row.className = "wizard-section-row d-flex align-items-center gap-2 mb-2"
    row.innerHTML = `
      <span class="text-muted fw-semibold" style="min-width: 1.5rem;">${count}.</span>
      <input type="text" name="section_titles[]" class="form-control" placeholder="Section title">
      <button type="button" class="btn btn-outline-danger btn-sm" data-action="wizard-sections#remove">
        <i class="ph ph-x"></i>
      </button>
    `
    this.listTarget.appendChild(row)
  }

  remove(event) {
    event.currentTarget.closest(".wizard-section-row").remove()
    this.renumber()
  }

  renumber() {
    this.listTarget.querySelectorAll(".wizard-section-row").forEach((row, i) => {
      row.querySelector("span").textContent = `${i + 1}.`
    })
  }
}
